import {Injectable, Injector} from '@angular/core';
import {
    LocaleConfigProvider,
    PES_UI_BO_FR,
    PES_UI_BO_US,
    PES_UI_CIRCUITS_FR,
    PES_UI_CIRCUITS_US,
    PES_UI_DASHBOARD_FR,
    PES_UI_DASHBOARD_US,
    PES_UI_FO_FR,
    PES_UI_FO_US,
    PES_UI_FR,
    PES_UI_US
} from '@pes/ui';
// French
import {CIRCUITS_TRANSLATIONS_FR} from '../../i18n/fr-FR/circuits-translations.fr';

/**
 * The provider that sets the application locales config.
 */
@Injectable()
export class AppLocaleConfigProvider extends LocaleConfigProvider {

    /**
     * Creates a new AppLocaleConfigProvider instance.
     */
    constructor(protected injector: Injector) {
        super(injector);
    }

    /**
     * @inheritDoc
     */
    public init(localeId: string = null): void {
        const userLocaleRef: string = this.currentLang || 'fr-FR';
        this.addLocales(
            {
                lang: 'fr-FR',
                translations: [
                    PES_UI_BO_FR,
                    PES_UI_FO_FR,
                    PES_UI_CIRCUITS_FR,
                    PES_UI_DASHBOARD_FR,
                    PES_UI_FR,
                    CIRCUITS_TRANSLATIONS_FR
                ]
            },
            {
                lang: 'en-US',
                translations: [
                    PES_UI_BO_US,
                    PES_UI_FO_US,
                    PES_UI_CIRCUITS_US,
                    PES_UI_DASHBOARD_US,
                    PES_UI_US
                ]
            }
        )
        super.init(userLocaleRef);
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/app-locale-config.provider.ts